import React from "react";

import { Spinner } from "@common/components/Spinner/Spinner";
import { generatePath, Navigate } from "react-router-dom";

interface RedirectProps {
  path: string;
  dynamicValues: Record<string, string | undefined>;
  search?: string;
}

export default function RedirectWithLoading({ path, dynamicValues, search }: RedirectProps) {
  const allDynamicValuesDefined = Object.values(dynamicValues).every((value) => !!value);

  if (!allDynamicValuesDefined) {
    return <Spinner />;
  }

  const pathname = generatePath(path, dynamicValues);
  return (
    <Navigate
      to={{ pathname, search }}
      replace
    />
  );
}
